export default __webpack_public_path__ + "static/media/caminhao.63889d73.svg";